import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Stack, Typography } from '@mui/material';

export function CancelRegistrationCompletedPage() {
  const { t } = useTranslation();

  return (
    <Stack spacing={2} sx={{ p: 3, height: '100%', overflow: 'auto' }}>
      <Box
        sx={(theme) => ({
          backgroundColor: theme.palette.background.paper,
          width: '100%',
          minHeight: 180,
          textAlign: 'center',
          alignContent: 'center'
        })}
      >
        <Typography variant="h3" component="h3" data-testid="primaryText">
          {t('eventRegistration.cancellationSuccessful')}
        </Typography>
        <Typography
          variant="h6"
          component="h4"
          data-testid="secondaryText"
          sx={{ paddingTop: '1.5rem' }}
        >
          {t('eventRegistration.cancellationSuccessfulText')}
        </Typography>
      </Box>
    </Stack>
  );
}
